import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OrganizationSettings } from '@/components/organizations/OrganizationSettings';
import { useAuth } from '@/contexts/auth/AuthContext';

const SettingsPage: React.FC = () => {
  const { currentOrganization } = useAuth();
  const [activeTab, setActiveTab] = useState("organization");

  if (!currentOrganization) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">No Organization Selected</h2>
          <p className="text-muted-foreground">Please select or create an organization to view settings</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6 pb-16">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Manage your organization and application settings
        </p>
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="organization">Organization</TabsTrigger>
          <TabsTrigger value="user">User Settings</TabsTrigger>
          <TabsTrigger value="security">Security</TabsTrigger>
        </TabsList>
        
        <TabsContent value="organization" className="space-y-4">
          <OrganizationSettings />
        </TabsContent>
        
        <TabsContent value="user" className="space-y-4">
          <div className="text-center p-8 border rounded-lg">
            <p className="text-muted-foreground">User settings will be implemented in a future update.</p>
          </div>
        </TabsContent>
        
        <TabsContent value="security" className="space-y-4">
          <div className="text-center p-8 border rounded-lg">
            <p className="text-muted-foreground">Security settings will be implemented in a future update.</p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
